import _ from 'lodash';
import { UserRole } from 'src/stores/auth/auth.slice';
import { useTypedSelector } from './useTypedSelector';

export const useCurrentUserRole = (): UserRole => {
  return useTypedSelector((state) => {
    return _.cloneDeep(state.auth.selectedRoleUser);
  });
};
